import {
  getRequest,
  postRequest,
  getRequestOfExam,
  postRequestByJson,
  putRequest,
  deleteRequest,
  postFileRequest,
  getFileRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";
function myThen(data) {
  if (data.result || data.status) {
    return Promise.resolve(data.data);
  } else {
    Message.error(data.failMsg);
    return Promise.reject(data.failMsg);
  }
}
export const getStudentGroup = (params = {}) => {
  return getRequest("/bpi/sign-info/query/group", params).then(myThen);
};
export const deleteStudentGroup = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/delete/group", params).then(myThen);
};
export const editStudentGroup = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/update/group", params).then(myThen);
};
export const createStudentGroup = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/create/group", params).then(myThen);
};

export const getSignupLabelList = (params = {}) => {
  return getRequest("/bpi/sign-info/query/customize", params).then(myThen);
};
export const deleteSignupLabel = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/delete/customize", params).then(
    myThen
  );
};
export const createSignupLabel = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/save/customize", params).then(
    myThen
  );
};

export const getApplyData = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/query/infoSetting", params).then(
    myThen
  );
};
export const deleteApply = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/delete/signinfo", params).then(
    myThen
  );
};

export const updateApply = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/update/signinfo", params).then(
    myThen
  );
};
export const createApply = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/save/info", params).then(myThen);
};
export const copyApply = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/copy/info", params).then(myThen);
};
export const getApplyList = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/query/pageList", params).then(
    myThen
  );
};
export const getStudentList = (params = {}) => {
  return postRequestByJson("/bpi/sign-up/page/query", params).then(myThen);
};
export const moveStudentGroup = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/move/userToGroup", params).then(
    myThen
  );
};
export const createStudent = (params = {}) => {
  return postRequestByJson("/bpi/sign-up/save/userinfo", params).then(myThen);
};
export const deleteStudent = (params = {}) => {
  return postRequestByJson("/bpi/sign-up/delete/userinfo", params).then(myThen);
};
export const batchDeleteStudent = (params = {}) => {
  return postRequestByJson("/bpi/sign-up/delete/moreUserInfos", params).then(
    myThen
  );
};
export const searchStudent = (params = {}) => {
  return postRequestByJson("/bpi/sign-info/page/usersignPage", params).then(
    myThen
  );
};
export const downloadApplyStudent = (params = {}) => {
  return getRequest("/bpi/sign-info/ex/applyStudents", params).then(myThen);
};
// 导入考生
export const importExamUserExcel = (params = {}) => {
  return postFileRequest("/base/common/importExamUserExcel", params).then(
    myThen
  );
};
// 导入考生准考证
export const importExamUserTicket = (params = {}) => {
  return postFileRequest("/base/common/importExamUserTicket", params).then(
    myThen
  );
};

// 获取考生详情
export const getStudentDetail = (params = {}) => {
  return postRequest("/base/userinfo/baseAnalysis", params).then(myThen);
};
// 获取考生答题正确率和能力图谱
export const getStudentAnalysis = (params = {}) => {
  return postRequest("/base/echarts/chartAnalysis", params).then(myThen);
};
// 学生参与的考试试卷
export const getStudentExamList = (params = {}) => {
  return postRequest("/base/userinfo/examPage", params).then(myThen);
};
// 学生学习记录
export const getStudentLearnList = (params = {}) => {
  return postRequest("/base/userinfo/learnVideoPage", params).then(myThen);
};
// 学生成绩变化
export const getStudentScoreTransformation = (params = {}) => {
  return postRequest("/base/echarts/scoreAnalysis", params).then(myThen);
};
//生成准考证
export const generateTicket = (params = {}) => {
  return postRequest("/base/common/generateTicket", params).then(myThen);
};

export const downloadTestTicket = (params) => {
  return getFileRequest(`/base/common/downloadTestTicket`, params);
};
